class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    }
  }
  
  customElements.define('cart-remove-button', CartRemoveButton);


class CartFreeShipping extends HTMLElement {
  constructor() {
    super();
    // fetch cart
    let cartItems = this.fetchCartData();
    // Shipping container
    const freeShipContainer = document.querySelector('.free-ship__container');
    // progress bar element
    const ProgressBarElement = document.getElementById('free-shipping-bar-element');
    // progress bar element for cart page
    const CartProgressBarElement = document.getElementById('cart-free-shipping-bar-element');
    // progress bar width element - percentage creates progress-effect
    const ProgressBarWidthElement = document.getElementById('free-shipping-width');
    // progress bar width element for cart page - percentage creates progress-effect
    const CartProgressBarWidthElement = document.getElementById('free-shipping-width');
    // message element
    const DisplayMessage = document.getElementById('free-shipping-message');
    // message element for cart page
    const CartDisplayMessage = document.getElementById('cart-free-shipping-message');
    // message element value $130
    const DisplayMessageValue = document.getElementById('free-shipping-message-value');
    // message element value $130 for cart page
    const CartDisplayMessageValue = document.getElementById('cart-free-shipping-message-value');
    // qualifier price
    const freeShippingQualifier = 13000;
    // current price
    let currentCartValue;

    const ProgressBarLoaderElement = document.getElementById('free-shipping-loader');
    const CartProgressBarLoaderElement = document.getElementById('cart-free-shipping-loader');

    // If there is a team store items in the cart that container will be empty (cart-drawer.liquid)
    if (freeShipContainer?.children?.length === 0) return;

    // For all countries but US remove shipping free container
    if (window.Shopify.country !== 'US') {
        freeShipContainer.innerHTML = '';
        return;
    }

    cartItems.then(response => response.json())
        .then(cartJSON => {
          currentCartValue = cartJSON.total_price;

          let cartDifferenceValue = Math.round((currentCartValue - freeShippingQualifier) * -1 / 100);
          const progressBarElementPercentage = Math.round(100 * currentCartValue / freeShippingQualifier);

          if(cartDifferenceValue <= 0) {
            // Update cart drawer
            ProgressBarLoaderElement.style.display = 'none';
            ProgressBarElement.style.display = 'block';
            DisplayMessage.innerHTML = "Your order will ship free!";
            ProgressBarWidthElement.style.width = '100%';
            
            // Update cart page
            CartProgressBarLoaderElement.style.display = 'none';
            CartProgressBarElement.style.display = 'block';
            CartDisplayMessage.innerHTML = "Your order will ship free!";
            CartProgressBarWidthElement.style.width = '100%';
          } else {
            // Update cart drawer
            DisplayMessageValue.innerHTML = "$" + cartDifferenceValue;
            ProgressBarLoaderElement.style.display = 'none';
            ProgressBarElement.style.display = 'block';
            ProgressBarWidthElement.style.width = progressBarElementPercentage + '%';

            // Update cart page
            CartDisplayMessageValue.innerHTML = "$" + cartDifferenceValue;
            CartProgressBarLoaderElement.style.display = 'none';
            CartProgressBarElement.style.display = 'block';
            CartProgressBarWidthElement.style.width = progressBarElementPercentage + '%';
          }
        })
  }
  // fetch cart
  async fetchCartData() {
    let file = "/cart.js"
    return fetch(file)
  }
}

customElements.define('free-shipping-progress-bar', CartFreeShipping);
  

  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
      
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
  
      this.addEventListener('change', debouncedOnChange.bind(this));
    }
  
    cartUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      });
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  
    onCartUpdate() {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          
          this.innerHTML = sourceQty.innerHTML;
        })
        .then(() => this.checkIfShouldDisplayUpsellWidget())
        .catch(e => {
          console.error(e);
        });
    }

    // Cart Page
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.cart__blocks'
        }
      ];
    }
  
    updateQuantity(line, quantity, name) {
      this.enableLoading(line);

      // Get AfterShip widget ID before the re-render
      const afterShipWidget = document.getElementsByClassName('apz-widget-root-container')?.[0];
      const afterShipWidgetID = afterShipWidget?.getAttribute('data-personalization-id');
  
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');
            
          if (parsedState.errors) {
            // displays stock message error
            this.displayToolTip(line);
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
  
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          // Reload AfterShip widget on re-render
          if (afterShipWidgetID) {
            window["pz-recommendations"].remove(afterShipWidgetID);
            window["pz-recommendations"].initialRecommendation(afterShipWidgetID);
          }

          // if parsedState.errors is undefined the code below uses the message store on the Window in theme.liquid
          
          // const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          // let message = '';
          // if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          //   if (typeof updatedValue === 'undefined') {
          //     message = window.cartStrings.error;
          //   } else {
          //     message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          //   }
          // }
          // this.updateLiveRegions(line, message);
  
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
          this.checkIfShouldDisplayUpsellWidget();
        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          //errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }

    updateLiveRegions(line, message) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
      const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    displayToolTip(line) {
      const lineItem = document.getElementById(`CartDrawer-Item-${line}`);
      const lineItemOverlay = lineItem.querySelector('.cart-item__overlay');
      let isClicked = false; 

      function DisplayStockMessage() {
        if (!isClicked) {
          // show message
          lineItemOverlay.style.display = "flex";
          lineItemOverlay.style.opacity = 1;
          setTimeout(function () {
            lineItemOverlay.style.display = "none";
          }, 2000)
        }
      }

      DisplayStockMessage();

      // allow user to hide tooltip before fade out.
      lineItemOverlay.addEventListener('click', function(e) {
        isClicked = true; 
        e.target.closest('.cart-item__overlay').style.display = "none";
      });

    }

    checkIfShouldDisplayUpsellWidget() {
      const afterShipWidget = document.getElementById('custom-aftership-widget-wrapper');
      const afterShipWidgetID = afterShipWidget?.getAttribute('data-personalization-id');

      const emptyCartState = document.getElementsByClassName('drawer__inner-empty')?.[0];

      // Hide Aftership upsell widget for empty cart; render if cart has at least 1 item
      if (emptyCartState) {
        afterShipWidget.style.display = 'none';
      } else if (afterShipWidgetID && !emptyCartState && afterShipWidget?.innerHTML == "") {          
        window["pz-recommendations"].remove(afterShipWidgetID);
        window["pz-recommendations"].initialRecommendation(afterShipWidgetID);
      }
    }
  
    enableLoading(line) {
      //const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      //mainCartItems.classList.add('cart__items--disabled');

      const lineItem = document.getElementById(`CartDrawer-Item-${line}`);

      const quantityButtons = lineItem.getElementsByClassName('quantity__button');

      const lineItemLoader = lineItem.querySelector('.cart-item__loader');

      const lineItemQuantity = lineItem.querySelector('.quantity');

      // qty loader
      lineItemLoader.style.display = "block";
      lineItemQuantity.style.backgroundColor = '#0000002b';

      Array.from(quantityButtons).forEach(button => {
        button.setAttribute('disabled', true);
      })

      // These don't even function, need to remove this.

      //const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      //const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
  
      //[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      //document.activeElement.blur();
      //this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  
    disableLoading(line) {
      //const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      //mainCartItems.classList.remove('cart__items--disabled');

      const lineItem = document.getElementById(`CartDrawer-Item-${line}`);

      const quantityButtons = lineItem.getElementsByClassName('quantity__button');

      const lineItemLoader = lineItem.querySelector('.cart-item__loader');

      const lineItemQuantity = lineItem.querySelector('.quantity');

      lineItemLoader.style.display = "none";
      lineItemQuantity.style.backgroundColor = 'unset';

      Array.from(quantityButtons).forEach(button => {
        button.removeAttribute('disabled');
      });
  
      //const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
      //const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
  
      //cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      //cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }
  
  customElements.define('cart-items', CartItems);
  
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
        constructor() {
          super();
  
        this.addEventListener('change', debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, ON_CHANGE_DEBOUNCE_TIMER))
        }
    });
  };
  